import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import {getField, updateField} from "vuex-map-fields";
import PrtfAchievementApiService from "../../../components/application/portfolio/Services/Api/PrtfAchievementApi";
import store from "../index.js.erb";

const AchApi = PrtfAchievementApiService;

const AchievementStore = {
    namespaced: true,
    state: ()=>({
        primary_color: "#2185d0",
        side_color: "#00796b",
        btn_color: "#f2711c",
        cancel_color: "#6D788D",
        date_picker_menu: false,
        date_picker: '',
        tab_item: '',
        current_item_tab: "GeneralInformation",

        portfolioAchievements: [],
        payload: {
            name: null,
            date_start: null,
            date_end: null,
            description: null,
            prtf_achievement_type_id: null,
            prtf_achievement_kind_id: null,
            prtf_achievement_subunit_id: null,
            prtf_achievement_unit_id: null,
            editable_score: false,
            file: null,
        },
        dialog: false,
        editModeForm: false,
    }),

    getters: {
        getPayloadAchievement(state) {
            return getField(state.payload);
        },

        filesPerson(state) {
            if (_.isEmpty(state.portfolioAchievements)) return [];

            const result = _.omitBy(state.portfolioAchievements, v => _.isNil(v.file));
            return _.map(result, (i) => {
                return {file: i.file, achievementName: i.name, date: i.date_end, typeName: i.prtf_achievement_type_name};
            });
        },
    },

    mutations: {
        updatePayloadAchievement(state, field) {
            updateField(state.payload, field);
        },

        setDateDatepicker: (state, flag) => state.date_picker_menu = flag,

        setDialog: (state, flag) => state.dialog = flag,

        editModeForm: (state, flag) => state.editModeForm = flag,

        setCurrentItemTab: (state, tab_item) => state.current_item_tab = tab_item,


        deleteAchievement: (state, id) => {
          state.personAchievements = _.filter(state.personAchievements, (i)=> {return i.id !== id})
        },

        editAchievement(state, achievement) {
            const editAchievement = _.cloneDeep(achievement);

            state.payload = {
                id: editAchievement.id,
                name: editAchievement.name,
                date_end: editAchievement.date_end,
                description: editAchievement.description,
                prtf_achievement_type_id: editAchievement.prtf_achievement_type_id,
                prtf_achievement_kind_id: editAchievement.prtf_achievement_kind_id,
                prtf_achievement_subunit_id: editAchievement.subunit?.id || null,
                prtf_achievement_unit_id: editAchievement.unit?.id || null,
                editable_score: editAchievement.editable_score,
                file: editAchievement.file,
            };
            state.editModeForm = true;
            state.dialog = true;
        },

        resetAchievement(state) {
            state.payload = {
                name: null,
                date_start: null,
                date_end: null,
                description: null,
                prtf_achievement_type_id: null,
                prtf_achievement_kind_id: null,
                prtf_achievement_subunit_id: null,
                prtf_achievement_unit_id: null,
                editable_score: false,
                file: null,
            }
        },

        setRating: (state, rating) => state.rating_portfolios = rating,

        setLoadingRating: (state, flag) => state.loading_rating = flag,

        setPortfolioAchievements(state, response) {
            state.portfolioAchievements = response;
        },

        replaceAchievementById(state, achievement) {
            const index = _.findIndex(state.portfolioAchievements, {"id": achievement.id});
            Vue.set(state.portfolioAchievements, index, achievement);
        },

        pushAchievementPortfolio(state, achievement) {
            state.portfolioAchievements.unshift(achievement);
        },

        deleteAchievementPortfolio(state, achievement) {
            const index = _.findIndex(state.portfolioAchievements, {"id": achievement.id});
            state.portfolioAchievements.splice(index, 1);
        },

    },

    actions: {

        async gePortfolioAchievements({commit}) {
            const response = await AchApi.index();
            if (_.isNull(response)) return;

            if (!response.data.hasOwnProperty("error")) {
                commit("setPortfolioAchievements", response.data.achievements);
            }
        },

        async createAchievement({state, commit, dispatch}) {
            const response = await AchApi.create(state.payload);
            if (_.isNull(response)) return;

            if (!response.data.hasOwnProperty("error")) {
                commit("pushAchievementPortfolio", response.data.achievement);
                dispatch('setDialogAction', false);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async updateAchievement({state, commit, dispatch}) {
            const response = await AchApi.update(state.payload.id, state.payload);
            if (_.isNull(response)) return;

            if (!response.data.hasOwnProperty("error")) {
                commit("replaceAchievementById", response.data.achievement);
                dispatch('setDialogAction', false);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async deleteAchievement({state, commit, dispatch}, id) {
            const response = await AchApi.delete(id);
            if (_.isNull(response)) return;

            if (!response.data.hasOwnProperty("error")) {
                commit("deleteAchievementPortfolio", response.data.achievement);
            } else {
                store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async setDialogAction(context, flag) {
            if (!flag) {
                context.commit('editModeForm',false);
                context.commit("resetAchievement");
            }
            context.commit("setDialog", flag);
        },

    },
}

export default AchievementStore